import { render, staticRenderFns } from "./ZekiMurenAtKucukCiftlikPark.vue?vue&type=template&id=52cbe0df&scoped=true&lang=pug&"
import script from "./ZekiMurenAtKucukCiftlikPark.vue?vue&type=script&lang=js&"
export * from "./ZekiMurenAtKucukCiftlikPark.vue?vue&type=script&lang=js&"
import style0 from "./ZekiMurenAtKucukCiftlikPark.vue?vue&type=style&index=0&id=52cbe0df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cbe0df",
  null
  
)

export default component.exports